import { render } from "./SubjectCard.vue?vue&type=template&id=22660b0c&scoped=true"
import script from "./SubjectCard.vue?vue&type=script&lang=js"
export * from "./SubjectCard.vue?vue&type=script&lang=js"

import "./SubjectCard.vue?vue&type=style&index=0&id=22660b0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22660b0c"]])

export default __exports__